import { render, staticRenderFns } from "./QueryGc.vue?vue&type=template&id=22ac5a7e&scoped=true"
import script from "./QueryGc.vue?vue&type=script&lang=js"
export * from "./QueryGc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac5a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ac5a7e')) {
      api.createRecord('22ac5a7e', component.options)
    } else {
      api.reload('22ac5a7e', component.options)
    }
    module.hot.accept("./QueryGc.vue?vue&type=template&id=22ac5a7e&scoped=true", function () {
      api.rerender('22ac5a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/ReceiveVolume/QueryGc.vue"
export default component.exports